import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
  ADD_NEW_COUNT,
  DELETE_COUNT,
  COUNT_FORM_TOOGLE_LOADING,
  SET_COUNT_LIST,
  SHOW_NOTIFICATION,
  UPDATE_COUNT,
} from "../constants";
import { formatCounts } from "./settingsActionsUtils";

/* COUNT LIST */
export const fetchCounts = () => {
  return async (dispatch) => {
    const response = await axios
      .get(API.counts.list)
      .then((response) => {
        const counts = formatCounts(response.data);
        dispatch({ type: SET_COUNT_LIST, payload: keyBy(counts, "_id") });
        return response.status;
      })
      .catch((err) => err);
    return response;
  };
};

// COUNTS
export const createCount = (newCount) => {
  return async (dispatch) => {
    dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
    const response = await axios
      .post(API.counts.create, newCount)
      .then((response) => {
        const count = formatCounts(response.data);
        dispatch({ type: ADD_NEW_COUNT, payload: count });
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "success",
            message: "Cuenta creada con éxito.",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const updateCount = (updatedCount) => {
  return async (dispatch) => {
    dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
    const response = await axios
      .put(`${API.counts.edit}${updatedCount._id}`, updatedCount)
      .then((response) => {
        const count = formatCounts(response.data);
        dispatch({ type: UPDATE_COUNT, payload: count });
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Cuenta actualizada.",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const deleteCounts = (Ids) => {
  return async (dispatch) => {
    dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
    const response = await axios
      .delete(`${API.counts.delete}`, { data: Ids })
      .then((response) => {
        dispatch({ type: DELETE_COUNT, payload: Ids });
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Cuentas eliminadas. ",
          },
        });
        return response.status;
      })
      .catch((err) => {
        dispatch({ type: COUNT_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};
